import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import { useEffect } from "react";
import "./submitModal.scss";
import {
  AppBar,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Buttons from "../../Controls/Buttons/Button";
import AddIcon from "@mui/icons-material/Add";

export default function ModalProcessor(props) {
  let { modalOpen, handleClose, handleSubmit } = props;

  const [open, setOpen] = useState();
  const [comments, setComments] = useState([""]); // Initial array with one empty string

  useEffect(() => {
    setOpen(modalOpen);
  }, [modalOpen]);

  const handleAddField = () => {
    setComments([...comments, ""]); // Add a new empty string to the array
  };

  const handleRemoveField = (index) => {
    const newComments = [...comments];
    newComments.splice(index, 1); // Remove the comment at the specified index
    setComments(newComments);
  };

  const handleCommentChange = (index, value) => {
    const newComments = [...comments];
    newComments[index] = value; // Update the comment at the specified index
    setComments(newComments);
  };

  const isSubmitDisabled =
    comments.length > 0 && comments.some((comment) => comment.trim() === "");

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="lg"
        className="reject-modal"
      >
        <DialogTitle
          id="alert-dialog-slide-title"
          className="alert-dialog-slide-title"
        >
          <AppBar className="alert-dialog-appbar">
            <div className="alert-dialog-modalTitle-wrap">
              <Typography className="modalTitle" id="modal-modal-title">
                {"Value"}
              </Typography>

              <IconButton
                aria-label="close"
                onClick={handleClose}
                className="processor-close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </AppBar>
        </DialogTitle>

        <DialogContent className="processor-dailogContent">
          {comments.map((comment, index) => (
            <div style={{ margin: "4px" }} key={index}>
              <TextField
                size="small"
                value={comment}
                required
                placeholder="word to be calculated"
                onChange={(event) =>
                  handleCommentChange(index, event.target.value)
                }
              ></TextField>
              <IconButton
                onClick={() => handleRemoveField(index)}
                className="processor-remove"
              >
                <CloseIcon />
              </IconButton>
            </div>
          ))}

          <IconButton
            variant="outlined"
            onClick={handleAddField}
            className="processor-add"
          >
            <AddIcon />
          </IconButton>

          <div>
            <Buttons
              className="reject-btn"
              variant="outlined"
              text="Submit"
              onClick={(e) => handleSubmit(comments)}
              disabled={isSubmitDisabled}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
